import { render, staticRenderFns } from "./deliveryNoticeDetailInquery.vue?vue&type=template&id=4d04e1e5"
import script from "./deliveryNoticeDetailInquery.vue?vue&type=script&lang=js"
export * from "./deliveryNoticeDetailInquery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports